const data = {
  en: {
    text: "Hello World!",
  },
  de: {
    text: "Hallo Welt!",
  },
  es: {
    text: "!Hola Mundo!",
  },
};

export { data };
